import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import ProjectsSection from './components/sections/ProjectsSection';
import CareersSection from './components/sections/CareersSection';
import ContactSection from './components/sections/ContactSection';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmlu13rk4349">
      <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-1" data-mp="2mn5ash5h0lgp">
        <Header data-id="element-2" data-mp="31b8jvzet8d9q" />
        <main className="flex-grow" data-id="element-3" data-mp="31bs1tg4gn1nr">
          <HeroSection data-id="element-4" data-mp="31cte1nx7pu72" />
          <AboutSection data-id="element-5" data-mp="2wk0av4he6tx3" />
          <ProjectsSection data-id="element-6" data-mp="2wjqgl4pbe0ll" />
          <CareersSection data-id="element-7" data-mp="2wifgbev2vaz8" />
          <ContactSection data-id="element-8" data-mp="2wi5nljineppu" />
        </main>
        <Footer data-id="element-9" data-mp="28tme50nv46w6" />
      </div>
    </BrowserRouter>;
}